import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';

import { SettingsProvider } from '@/lib/settings';
import { AuthProvider } from '@/lib/auth';

import PublicLayout from '@/components/PublicLayout';

// Public pages
import DynamicPage from '@/pages/DynamicPage';
import ReferenceList from '@/pages/ReferenceList';
import ReferenceDetail from '@/pages/ReferenceDetail';
import BlogList from '@/pages/BlogList';
import BlogDetail from '@/pages/BlogDetail';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';

// Admin pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminPagesList from '@/pages/admin/AdminPagesList';
import AdminPageEditor from '@/pages/admin/AdminPageEditor';
import AdminServices from '@/pages/admin/AdminServices';
import AdminProjects from '@/pages/admin/AdminProjects';
import AdminBlog from '@/pages/admin/AdminBlog';
import AdminRedirects from '@/pages/admin/AdminRedirects';
import AdminMessages from '@/pages/admin/AdminMessages';
import AdminMedia from '@/pages/admin/AdminMedia';
import AdminSettings from '@/pages/admin/AdminSettings';
import AdminUsers from '@/pages/admin/AdminUsers';

function App() {
    return (
        <HelmetProvider>
            <SettingsProvider>
                <AuthProvider>
                    <div className="App">
                        <BrowserRouter>
                            <Routes>
                                {/* Admin routes (no public layout) */}
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<AdminLayout />}>
                                    <Route index element={<AdminDashboard />} />
                                    <Route path="pages" element={<AdminPagesList />} />
                                    <Route path="pages/:id" element={<AdminPageEditor />} />
                                    <Route path="services" element={<AdminServices />} />
                                    <Route path="projects" element={<AdminProjects />} />
                                    <Route path="blog" element={<AdminBlog />} />
                                    <Route path="redirects" element={<AdminRedirects />} />
                                    <Route path="messages" element={<AdminMessages />} />
                                    <Route path="media" element={<AdminMedia />} />
                                    <Route path="settings" element={<AdminSettings />} />
                                    <Route path="users" element={<AdminUsers />} />
                                </Route>

                                {/* Public routes with layout */}
                                <Route
                                    path="/"
                                    element={
                                        <PublicLayout>
                                            <DynamicPage />
                                        </PublicLayout>
                                    }
                                />
                                <Route
                                    path="/reference"
                                    element={
                                        <PublicLayout>
                                            <ReferenceList />
                                        </PublicLayout>
                                    }
                                />
                                <Route
                                    path="/reference/:slug"
                                    element={
                                        <PublicLayout>
                                            <ReferenceDetail />
                                        </PublicLayout>
                                    }
                                />
                                <Route
                                    path="/blog"
                                    element={
                                        <PublicLayout>
                                            <BlogList />
                                        </PublicLayout>
                                    }
                                />
                                <Route
                                    path="/blog/:slug"
                                    element={
                                        <PublicLayout>
                                            <BlogDetail />
                                        </PublicLayout>
                                    }
                                />
                                <Route
                                    path="/privatnost"
                                    element={
                                        <PublicLayout>
                                            <PrivacyPage />
                                        </PublicLayout>
                                    }
                                />
                                <Route
                                    path="/uvjeti"
                                    element={
                                        <PublicLayout>
                                            <TermsPage />
                                        </PublicLayout>
                                    }
                                />
                                {/* Catch-all dynamic page (must be LAST among public) */}
                                <Route
                                    path="/:slug"
                                    element={
                                        <PublicLayout>
                                            <DynamicPage />
                                        </PublicLayout>
                                    }
                                />
                            </Routes>
                        </BrowserRouter>
                        <Toaster position="top-right" richColors />
                    </div>
                </AuthProvider>
            </SettingsProvider>
        </HelmetProvider>
    );
}

export default App;
